import Head from 'next/head'

import Layout from '../components/Layout'

export default function Testimonials(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | Testimonials</title>
      </Head>
      <h1 className="mb-4 text-center text-2xl font-semibold">Testimonials</h1>
      <section>
        <div className="space-y-4">
          <figure>
            <blockquote>
              <p className="italic">
                With compassion and humor, Bob guides parents through what is an
                emotional time. Through his gentle touch, participants are
                comforted as they participate in a four thousand year old Jewish
                tradition.
              </p>
            </blockquote>
            <figcaption className="font-semibold">
              — Rabbi Alexander Davis
            </figcaption>
          </figure>
          <figure>
            <blockquote>
              <p className="italic">
                Our son, Ilan was born six weeks early in a rather eventful
                birth. Needless to say, when we got the green light to have his
                brit performed at three weeks of age (on a baby under five
                pounds!) it was rather traumatic for me as his mother. Dr.
                Karasov was calm, caring and nurturing and was able to turn a
                potentially harrowing experience into a meaningful and spiritual
                moment. His humor, support and wisdom were exactly what was
                needed.
              </p>
            </blockquote>
            <figcaption className="font-semibold">
              — Hana Gruenberg, Mpls Jewish Federation
            </figcaption>
          </figure>
          <figure>
            <blockquote>
              <p className="italic">
                As new parents we were so apprehensive prior to our son David's
                bris. When Bob arrived for the ceremony, his warmth, joy and
                confidence calmed us in moments. Bob performed the ceremony
                skillfully and quickly. The moment the procedure was over, Bob
                held David close, and we watched with awe as Bob calmed our son
                with his soulful singing of the prayers. We remember David's
                bris as a wonderful family celebration. We feel blessed to have
                had Bob Karasov as our mohel.
              </p>
            </blockquote>
            <figcaption className="font-semibold">
              — Anne Hope, Herzl Camp Director
            </figcaption>
          </figure>
        </div>
      </section>
    </Layout>
  )
}
